import React from 'react';
import './WavyCard.styl';
import classNames from 'classnames';

export default function WavyCard({title, children, color, className, ...props}) {
  return (
    <div className={classNames('wavy-card', className)} {...props}>
      <div className="wavy-card-inner">
        <div className="header">
          <WavyBackground color={color} className="wavy-background" />
          <h3>{title}</h3>
        </div>

        <div className="body">{children}</div>
      </div>
    </div>
  );
}

const WavyBackground = ({color, className}) => (
  <svg viewBox="0 0 245 42" preserveAspectRatio={'none'} className={className}>
    <g transform="translate(-519.000000, -765.000000)">
      <g id="Group-5" transform="translate(519.000000, 765.000000)">
        <path
          d="M3,0 L242,0 C243.656854,-3.04359188e-16 245,1.34314575 245,3 L245,42 L245,42 L0,42 L0,3 C-2.02906125e-16,1.34314575 1.34314575,3.04359188e-16 3,0 Z"
          fill={color}
        />
        <path
          d="M0.95074443,24.3556076 C37.8222221,1.63376187 76.8974642,0.848559347 118.176471,22 C158.781757,42.8062254 199.996305,37.9302094 241.820115,7.37195215 C242.711991,6.72032866 243.963247,6.91507426 244.614883,7.80694089 C244.865131,8.1494454 245,8.56264599 245,8.9868318 L245,40 C245,41.1045695 244.104569,42 243,42 L2,42 C0.8954305,42 1.3527075e-16,41.1045695 0,40 L0,26.0582687 C1.9607581e-06,25.3641918 0.35985495,24.71974 0.95074443,24.3556076 Z"
          fill="#FFFFFF"
          opacity={0.1}
        />
        <path
          d="M2.56032561,27.4961367 C25.1082823,34.0766926 60.1241214,31.9113137 107.607843,21 C156.267689,9.81842408 201.498372,7.3974354 243.299892,13.7370339 C244.277474,13.885296 245,14.7256617 245,15.7144226 L245,40 C245,41.1045695 244.104569,42 243,42 L2,42 C0.8954305,42 2.09738034e-15,41.1045695 0,40 L0,29.4160652 C-2.26374366e-05,28.3114832 0.895417998,27.4160426 2,27.4160426 C2.18962773,27.4160426 2.37829182,27.4430106 2.56032561,27.4961367 Z"
          fill="#FFFFFF"
          opacity={0.1}
        />
      </g>
    </g>
  </svg>
);
